import { Trans, type HekateDisplayField } from '@onshape/www-inertia';

export default class SubmitFieldCoordinator {
  /** True if if we should disable the submit button */
  private isSubmitDisabled: Ref<boolean>;

  private readonly onSubmitForm: (_evt: Event) => void;

  private readonly field: Ref<HekateDisplayField>;

  private readonly submitText: string;

  constructor({
    field,
    isRecaptchaSolved,
    isSubmitDisabled,
    onSubmitForm,
    submitText,
  }: {
    field: Ref<HekateDisplayField>;
    isRecaptchaSolved: Ref<boolean>;
    isSubmitDisabled: Ref<boolean>;
    onSubmitForm: (_evt: Event) => void;
    submitText: string;
  }) {
    this.onSubmitForm = onSubmitForm;
    this.isSubmitDisabled = isSubmitDisabled;
    this.field = field;
    this.submitText = submitText;

    watch(isRecaptchaSolved, (newVal) => {
      if (newVal) {
        this.field.value.errorMessages = [];
      } else {
        this.field.value.errorMessages = [
          {
            message: Trans.byKey('recaptchaRequired'),
          },
        ];
      }
    });
  }

  public setup() {
    return {
      isSubmitDisabled: this.isSubmitDisabled,
      onClickSubmit: this.onSubmitForm.bind(this),
      submitText: this.submitText,
    };
  }
}
